import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { EnumHelper } from "../../../../helpers/EnumHelper";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { NFLookupWithHoldingTaxRate } from "../../../Shared/NewForms/NFLookupWithHoldingTaxRate";
import { NFLookupAccount } from "../../../Shared/NewForms/NFLookupAccount";
import { useTranslation } from "react-i18next";

const AccrualMainDetail = () => {
  const { t } = useTranslation();

  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Name")} fieldName={"name"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("UniqueCode")} fieldName={"uniqueCode"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFTextInput fieldName={"description"} title={t("Description")} />
        </Col>
        <Col sm={6}>
          <NFDateInput title={t("CreatedDate")} fieldName={"createdDate"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupInput items={EnumHelper.AccrualDetailBelongToTypeEnum()} title={t("IncomeType")} fieldName="incomeType" />
        </Col>
        <Col sm={6}>
          <NFLookupWithHoldingTaxRate title={t("WithHoldingTaxRate")} fieldName="withholdingTaxRateId" />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupAccount title={t("SettlementsAccount")} fieldName="settlementsAccountId" />
        </Col>
        <Col sm={6}>
          <NFLookupAccount title={t("ExpensesAccount")} fieldName="expensesAccountId" />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupAccount title={t("WithholdingTax")} fieldName="withholdingTaxId" />
        </Col>
        <Col sm={3}>
          <NFLookupAccount title={t("PensionContributionExpenseAccount")} fieldName="pensionContributionExpenseAccountId" />
        </Col>
        <Col sm={3}>
          <NFLookupAccount title={t("PensionContributionAccount")} fieldName="pensionContributionAccountId" />
        </Col>
      </Row>
    </>
  );
};

export default AccrualMainDetail;
